import { useCallback } from 'react';
import { TextInput } from 'react-native-paper';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { setBusinessSearchText } from '../redux/businessListSlice';
import { debounce } from 'lodash';
import { useAppTheme } from '../theme';

import { BottomSheetMethods } from '@gorhom/bottom-sheet/lib/typescript/types';

interface Props {
  bottomSheetRef?: React.RefObject<BottomSheetMethods>;
}

export default function BusinessListSearch({ bottomSheetRef }: Props) {
  const theme = useAppTheme();
  const dispatch = useAppDispatch();
  const { businessSearchText } = useAppSelector((state) => state.businessList);

  const changeHandler = (text: string) => {
    dispatch(setBusinessSearchText(text));
  };
  const debouncedChangeHandler = useCallback(debounce(changeHandler, 300), []);

  return (
    <TextInput
      defaultValue={businessSearchText}
      onFocus={() => {
        bottomSheetRef?.current?.snapToIndex(3);
      }}
      underlineColor="transparent"
      onChangeText={debouncedChangeHandler}
      placeholder="Search"
      placeholderTextColor={theme.colors.onBackground}
      autoCapitalize="words"
      style={{
        width: '80%',
        borderRadius: 4,
        borderWidth: 1,
        borderColor: theme.colors.backgroundBorder,
        backgroundColor: theme.colors.background,
        color: theme.colors.onBackground,
        height: 40,
      }}
      //   https://gorhom.github.io/react-native-bottom-sheet/keyboard-handling
      //   onFocus={}
      //   onBlur={}
    />
  );
}
